import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './Footer.css';
import { useLenis, scrollToTarget } from './SmoothScroll';
import ParticleWordmark from './ParticleWordmark';
import { useConsent } from './Consent';
import { COMPANY } from '../data/site';
import { CATEGORY_ORDER, MACHINE_CATEGORIES } from '../data/machines';

const NAV = ['about', 'services', 'history', 'gallery', 'contact'];

const Footer = () => {
  const { t } = useTranslation();
  const lenis = useLenis();
  const consent = useConsent();
  const ref = useRef(null);

  // Obří nápis se při doscrollování k patičce vysune a roztáhne.
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end end'] });
  const markY = useTransform(scrollYProgress, [0, 1], ['35%', '0%']);

  return (
    <footer ref={ref} className="footer">
      <div className="container">
        <div className="footer__grid">
          <div>
            <h3 className="footer__heading">{t('footer.nav')}</h3>
            <ul className="footer__list">
              {NAV.map((id) => (
                <li key={id}>
                  <Link to={`/#${id}`}>{t(`nav.${id}`)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="footer__heading">{t('footer.services')}</h3>
            <ul className="footer__list">
              {CATEGORY_ORDER.map((key) => (
                <li key={key}>
                  <Link to={MACHINE_CATEGORIES[key].path}>{t(`services.${key}.name`)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="footer__heading">{t('footer.contact')}</h3>
            <ul className="footer__list">
              <li>
                <a href={COMPANY.phoneHref}>{COMPANY.phone}</a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
              </li>
              <li>{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <motion.div className="footer__mark" style={{ y: markY }}>
          <ParticleWordmark text="KOVOJOCH" />
        </motion.div>

        <div className="footer__bottom">
          <p>
            © {new Date().getFullYear()} {COMPANY.name} {t('footer.rights')}
          </p>
          <button type="button" className="footer__top" onClick={consent.openSettings}>
            {t('consent.footerLink')}
          </button>
          <button type="button" className="footer__top" onClick={() => scrollToTarget(lenis, 0, { offset: 0 })}>
            {t('footer.top')} <span aria-hidden="true">↑</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
